<template>
  <div class="mobile-wrapper">
    <div class="fixed-banner">
      <div class="container-fluid banner-alt" :style="getStyle()">
        <div class="row">
          <div class="col-12 banner-title">
            <span class="material-icons md-36" @click="goBack">keyboard_arrow_left</span>
            <span class="title-text" @click="goBack">{{ $t('message.loyalty') }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-white vform position-relative">
      <div class="justify-content-center">
        <div class="col-12 bg-white py-4">
          <div class="container mt-4 pt-4">
            <div class="text-center">
              <div>{{ $t('message.loyaltyPts') }}</div>
              <div>{{parseInt(dbuser.RewardPoints) | formatNumber}}</div>
            </div>
            <hr />
            <div class="row">
              <div class="col-6 text-success text-center">
                <div>{{ $t('message.ptsEarned') }}</div>
                <div>+ {{parseInt(dbuser.EarnedRewardPoints) | formatNumber}}</div>
              </div>
              <div class="col-6 text-red text-center">
                <div>{{ $t('message.ptsSpent') }}</div>
                <div>- {{parseInt(dbuser.SpentRewardPoints) | formatNumber}}</div>
              </div>
            </div>
            <hr />
            <div v-show="error" class="w-100 mt-4">
              <div class="alert alert-danger" role="alert">
                <strong>{{ error }}</strong>
              </div>
            </div>
            <div v-show="success" class="w-100 mt-4">
              <div class="alert alert-success" role="alert">
                <strong>{{ $t('message.orderPlacedSuccessfully') }}</strong>
              </div>
            </div>
          </div>
          <div class="container">
            <div v-for="(order, index) in pageOrders" :key="index" class="row">
              <div class="col-sm-12 order-items font-weight-bold">
                <div>
                  <div class="row">
                    <div class="col-4 order-number loyalty">
                      <div>{{ $t('message.orderNo') }}.</div>
                      <span>{{(order.OrderNumber?'#':'')}}{{order.OrderNumber}}</span>
                    </div>
                    <div class="col-8 right-side">
                      <div class="order-date text-right">{{getCreateDate(order)}}</div>
                      <div class="text-right">
                        <span
                          class="text-red"
                          v-if="parseInt(order.RedeemPoints)>0"
                        >&nbsp;-{{parseInt(order.RedeemPoints) | formatNumber}} pts</span>
                        <span
                          class="text-success"
                          v-if="parseInt(order.RewardPoints)>0"
                        >&nbsp;+{{parseInt(order.RewardPoints) | formatNumber}} pts</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-12">
                <hr />
              </div>
            </div>
            <div v-if="pageOrders.length == 0">
              <message :message="getNoOrderAvailable" />
            </div>
          </div>
          <div class="text-center">
            <button
              v-if="orders.length != pageOrders.length"
              class="btn btn-info"
              :style="mobileStyles.btn"
              @click="moreCallback()"
            >{{ $t('message.more') }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import shared from "../../sharedscripts/user/Loyalty.js";
import Message from "./../shared/Message";
import common from "../../sharedscripts/Common/commonMobile";

export default {
  components: {
    Message
  },

  data() {
    return {
      page: 2,
      perPage: 3,
      records: 0,
      options: {
        theme: "bootstrap4",
        chunksNavigation: "scroll",
        texts: {
          count: "",
          prev: "prev"
        }
      },
      orders: [],
      pageOrders: [],
      loading: false,
      error: "",
      success: false
    };
  },
  computed: {
    ...mapGetters(["user", "currentstore", "mobileStyles", "currentStoreDoc"]),
    ...shared.computed,
    getNoOrderAvailable() {
      return this.$t("message.noOrderAvailable");
    }
  },
  watch: {
    user(newValue) {
      if (newValue) {
        this.initOrders(this.currentStoreDoc.ID);
      }
    }
  },
  created() {
    if (this.user) {
      this.initOrders(this.currentStoreDoc.ID);
    }
  },
  methods: {
    ...common.methods,
    ...shared.methods
  }
};
</script>

